import React, { Component } from 'react';
import s from './PromoCodeForm.css';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import submit from './submit';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import getLocationsQuery from './getLocations.graphql';
import getActiveDeliveryTypeQuery from './getActiveDeliveryType.graphql';
//Style
import cx from 'classnames';
import {
	Form,
	Col,
	Row,
	InputGroup,
	Container
} from 'react-bootstrap';
import Link from '../../../Link';
import messages from '../../../../locale/messages';
import validate from './validate';
import { normalizePromoCode, normalizePromoValue } from './normalize';

import DatePicker from '../../../Common/DatePicker';
import Loader from '../../../Common/Loader';
import ImageDropzone from './ImageDropzone';
import Switch from 'react-switch';
import Multiselect from 'multiselect-react-dropdown';

import { api, promoCodeImageUploadDir } from '../../../../config';

//image
import defaultIcon from '../../../../../public/Icons/defaultIconAdmin.svg';

export class PromoCodeForm extends Component {

	static defaultProps = {
		currency: 'IDR',
		promoId: null,
		promoCurrency: 'IDR',
		expiryDate: null,
		validFrom: new Date()
	}

	componentDidMount() {
		const { initialValues, initialize } = this.props;
		if (!initialValues) {
			initialize({ type: 1, variant: 'FREE_BOOKING_FEE' }); // 1 = percentage type discount
		} else if (initialValues && !initialValues.variant) {
			initialize({ ...initialValues, variant: 'FREE_BOOKING_FEE' });
		}

		this.state = {
			promoCodeType: initialValues || 1
		}
	}

	handlePromoTypeChange(event) {
		const { change } = this.props;
		const newType = parseInt(event.target.value, 10);
		// Reset promo value when type changes
		change('PromoCodeForm', 'promoValue', '');
	}

	renderField = ({ input, label, type, meta: { touched, error }, helperText, labelClass, fieldClass, placeholder }) => {
		const { formatMessage } = this.props.intl;
		return (
			<Form.Group className={cx(s.space5, 'positionRelative')}>
				<Form.Label className={'inputLabel'}>{label}</Form.Label>
				<Form.Control {...input} placeholder={placeholder} type={type} className={fieldClass} />
				{helperText && <span className='text-sm text-muted font-italic'>{helperText}</span>}
				{touched && error && <span className={cx(s.errorMessage, 'errorMessageRTL')}>{formatMessage(error)}</span>}
			</Form.Group>
		)
	}

	renderFieldDiscount = ({ input, label, type, meta: { touched, error }, helperText, labelClass, fieldClass, placeholder, promoType, promoCurrency }) => {
		const { formatMessage } = this.props.intl;
		return (
			<div className={cx('inputFormAddon', 'addonBorder')}>
				<Form.Group className={cx(s.space5, 'positionRelative')}>
					<Form.Label className={cx('inputLabel')}>{label}</Form.Label>
					<InputGroup>
						{
							Number(promoType) === 2 && <InputGroup.Append>
								<InputGroup.Text>
									{
										promoCurrency
									}
								</InputGroup.Text>
							</InputGroup.Append>
						}
						<Form.Control
							{...input}
							placeholder={placeholder}
							type={type}
							className={cx(fieldClass, promoType !== 2 && 'inputLeft')}
							normalize={(value) => normalizePromoValue(value, promoType)}
						/>
						{
							Number(promoType) !== 2 && <InputGroup.Append className={'promoCodeFeeAddon'}>
								<InputGroup.Text>%</InputGroup.Text>
							</InputGroup.Append>
						}
					</InputGroup>
					{helperText && <span className='text-sm text-muted font-italic'>{helperText}</span>}
					{touched && error && <span className={cx(s.errorMessage, 'errorMessageRTL')}>{formatMessage(error)}</span>}
				</Form.Group>
			</div>
		)
	}

	renderTextAreaField = ({ input, label, type, meta: { touched, error }, children, labelClass, fieldClass, placeholder }) => {
		const { formatMessage } = this.props.intl;
		return (
			<Form.Group className={cx(s.space5, 'positionRelative')}>
				<Form.Label className={'inputLabel'}>{label}</Form.Label>
				<Form.Control as="textarea" rows="4" {...input} placeholder={placeholder} type={type} className={fieldClass} />
				{touched && error && <span className={cx(s.errorMessage, 'errorMessageRTL')}>{formatMessage(error)}</span>}
			</Form.Group>
		)
	}

	renderSwitch = ({ input, label, meta: { touched, error } }) => {
		const { formatMessage } = this.props.intl;
		return (
			<Form.Group className={cx(s.space5, 'positionRelative')}>
				<div className={s.switchContainer}>
					<Switch
						onChange={(checked) => input.onChange(checked)}
						checked={input.value ? true : false}
						onColor="#E62529"
						offColor="#dce0e0"
						handleDiameter={20}
						uncheckedIcon={false}
						checkedIcon={false}
						height={25}
						width={45}
					/>
					<Form.Label className={s.switchLabel} onClick={() => input.onChange(!input.value)}>{label}</Form.Label>
				</div>
				{touched && error && <span className={cx(s.errorMessage, 'errorMessageRTL')}>{formatMessage(error)}</span>}
			</Form.Group>
		)
	}

	renderSelect = ({ input, label, options, meta: { touched, error } }) => {
		const { formatMessage } = this.props.intl;
		return (
			<Form.Group className={cx(s.space5, 'positionRelative')}>
				<Form.Label className={'inputLabel'}>{label}</Form.Label>
				<Multiselect
					options={options}
					displayValue="label"
					selectedValues={options ? options.filter(option => input.value && input.value.includes(option.value)) : []}
					onSelect={(selectedList) => {
						input.onChange(selectedList.map(item => item.value));
					}}
					onRemove={(selectedList) => {
						input.onChange(selectedList.map(item => item.value));
					}}
					placeholder="Select Area"
					style={{
						searchBox: {
							border: '1px solid #dce0e0',
							borderRadius: '4px',
							minHeight: '40px',
							padding: '5px'
						},
						chips: {
							background: '#E62529',
							color: 'white',
							borderRadius: '4px'
						},
						optionContainer: {
							border: '1px solid #dce0e0',
							borderRadius: '4px'
						}
					}}
				/>
				{touched && error && <span className={cx(s.errorMessage, 'errorMessageRTL')}>{formatMessage(error)}</span>}
			</Form.Group>
		)
	}

	render() {
		const {
			handleSubmit,
			currency,
			promoId,
			promoType,
			promoCurrency,
			validFrom,
			expiryDate,
			loading,
			submitting,
			promoCodeImage,
			getLocations,
			getActiveDeliveryType,
			isStockEnabled,
			isFirstOrderOnly
		} = this.props;
		const { formatMessage } = this.props.intl;

		return (
			<div className={cx(s.space5, s.spaceTop5)}>
				<Container fluid>
					<Form className={s.fullWidth} onSubmit={handleSubmit(submit)}>
						<Row>
							<Col xl={12} lg={12} md={12} sm={12} xs={12} className={s.blackCenter}>
								<div className={s.blackCenterSection}>
									<Row>
										<Col lg={6} md={12} sm={12} xs={12}>
											<Form.Group className={s.space3}>
												<div className={cx(s.centerFlex, s.profileImgSection)}>
													<label for="promoCodeImage">{formatMessage(messages.promoCodeImage)}</label>
													{
														promoCodeImage && <div className={s.backgroundImg} style={{ backgroundImage: `url(${api.apiEndpoint + promoCodeImageUploadDir}${promoCodeImage})` }} />
													}
													{
														!promoCodeImage && <div className={cx(s.backgroundImg, s.defaultIcon)} style={{ backgroundImage: `url(${defaultIcon})` }} />
													}

													<ImageDropzone
														key={'promoCodeImage'}
														className={cx(s.btnSecondary, s.profileNoPadding)}
														subTextClass={s.subText}
														subText={formatMessage(messages.maximumUploadSizeLabel)}
														defaultMessage={formatMessage(messages.chooseFile)}
													/>
												</div>
											</Form.Group>
											<Col lg={12} md={12} sm={12} xs={12}>
												<Field
													name="title"
													type="text"
													placeholder={formatMessage(messages.title)}
													component={this.renderField}
													label={formatMessage(messages.title)}
													labelClass={s.labelText}
													fieldClass={s.formControlInput}
												/>
												<Field
													name="description"
													type="text"
													placeholder={formatMessage(messages.description)}
													component={this.renderTextAreaField}
													label={formatMessage(messages.description)}
													labelClass={s.labelText}
												/>
											</Col>
										</Col>
										<Col lg={6} md={12} sm={12} xs={12}>
											<Form.Group className={cx(s.space5, 'positionRelative')}>
												<label for='variant' className={'inputLabel'}>{formatMessage(messages.variant)}</label>
												<Field name="variant" className={cx(s.formControlSelect, s.formControlInput)} component="select">
													<option value="FREE_BOOKING_FEE">{formatMessage(messages.freeBookingFee)}</option>
													<option value="FREE_DELIVERY">{formatMessage(messages.freeDelivery)}</option>
												</Field>
											</Form.Group>
											<Row>
												<Col lg={6} md={6} sm={6} xs={12}>
													<Form.Group className={s.space3}>
														<div>
															<Field
																name="code"
																type="text"
																placeholder={formatMessage(messages.code)}
																component={this.renderField}
																label={formatMessage(messages.code)}
																labelClass={s.labelText}
																fieldClass={s.formControlInput}
																normalize={normalizePromoCode}
															/>
														</div>
													</Form.Group>
												</Col>
												<Col lg={6} md={6} sm={6} xs={12}>
													<Form.Group className={cx(s.space5, 'positionRelative')}>
														<label for='promoType' className={'inputLabel'}>{formatMessage(messages.promoType)}</label>
														<Field name="type" className={cx(s.formControlSelect, s.formControlInput)}
															component="select" onChange={this.handlePromoTypeChange.bind(this)}>
															<option value={1}>{formatMessage(messages.percentage)}</option>
															<option value={2}>{formatMessage(messages.fixedAmount)}</option>
														</Field>
													</Form.Group>
												</Col>
											</Row>

											<Form.Group className={s.space3}>
												<Field
													name="promoValue"
													type="number"
													placeholder="Discount value"
													component={this.renderFieldDiscount}
													label={formatMessage(messages.discount)}
													labelClass={s.labelText}
													fieldClass={s.formControlInput}
													promoType={promoType}
													promoCurrency={promoCurrency}
												/>
											</Form.Group>

											<Form.Group className={s.space3}>
												<Field
													name="maxValue"
													type="number"
													placeholder="Discount max value"
													helperText="Max value (in IDR) to limit percentage discount"
													component={this.renderField}
													label="Max discount value"
													labelClass={s.labelText}
													fieldClass={s.formControlInput}
													promoCurrency={promoCurrency}
												/>
											</Form.Group>

											<Form.Group className={cx(s.space5, 'positionRelative')}>
												<label for='currency' className={'inputLabel'}>{formatMessage(messages.currency)}</label>
												<Field name="currency" className={cx(s.formControlSelect, s.formControlInput)} component="select">
													{
														currency?.availableCurrencies?.map(currency => (
															<option key={currency.id} value={currency.symbol}>{currency.symbol}</option>
														))
													}
												</Field>
											</Form.Group>

											<Field
												name="isStockEnabled"
												component={this.renderSwitch}
												label={formatMessage(messages.stockEnabled)}
											/>

											{
												isStockEnabled && (
													<Form.Group className={s.space3}>
														<Field
															name="stock"
															type="number"
															placeholder={formatMessage(messages.stock)}
															component={this.renderField}
															label={formatMessage(messages.stock)}
															labelClass={s.labelText}
															fieldClass={s.formControlInput}
														/>
													</Form.Group>
												)
											}

											<Field
												name="isFirstOrderOnly"
												component={this.renderSwitch}
												label={formatMessage(messages.isFirstOrderOnly)}
											/>

											{
												!isFirstOrderOnly && (
													<Form.Group className={s.space3}>
														<Field
															name="minOrderCount"
															type="number"
															placeholder="e.g. 3"
															helperText={formatMessage(messages.minOrderCountHelper)}
															component={this.renderField}
															label={formatMessage(messages.minOrderCount)}
															labelClass={s.labelText}
															fieldClass={s.formControlInput}
														/>
													</Form.Group>
												)
											}

											<Form.Group className={s.space3}>
												<Field
													name="minOrderValue"
													type="number"
													placeholder="e.g. 50000"
													helperText={formatMessage(messages.minOrderValueHelper)}
													component={this.renderFieldDiscount}
													label={formatMessage(messages.minOrderValue)}
													labelClass={s.labelText}
													fieldClass={s.formControlInput}
													promoType={2}
													promoCurrency="IDR"
												/>
											</Form.Group>

											<Row>
												<Col lg={6} md={6} sm={6} xs={12}>
													<Form.Group className={cx(s.space5, 'positionRelative', 'promoCodeDatePicker')}>
														<label for='validFrom' className={'inputLabel'}>Valid From</label>
														<DatePicker
															placeholder={formatMessage(messages.expireDate)}
															formName={'PromoCodeForm'}
															fieldName={'validFrom'}
															initialDate={validFrom}
														/>
													</Form.Group>
												</Col>
												<Col lg={6} md={6} sm={6} xs={12}>
													<Form.Group className={cx(s.space5, 'positionRelative', 'promoCodeDatePicker')}>
														<label for='expiryDate' className={'inputLabel'}>{formatMessage(messages.expireDate)}</label>
														<DatePicker
															placeholder={formatMessage(messages.expireDate)}
															formName={'PromoCodeForm'}
															fieldName={'expiryDate'}
															initialDate={expiryDate}
														/>
													</Form.Group>
												</Col>
											</Row>

											<Form.Group className={cx(s.space5, 'positionRelative')}>
												<label for='isPrivate' className={'inputLabel'}>{formatMessage(messages.privacyType)}</label>
												<Field name="isPrivate" className={cx(s.formControlSelect, s.formControlInput)} component="select">
													<option value={0}>{formatMessage(messages.public)}</option>
													<option value={1}>{formatMessage(messages.private)}</option>
												</Field>
											</Form.Group>

											<Form.Group className={cx(s.space5, 'positionRelative')}>
												<Field
													name="locationIds"
													component={this.renderSelect}
													label="Available in Area"
													options={getLocations?.getLocations?.filter(location => location.isActive)?.map(location => ({
														value: location.id,
														label: location.locationName
													}))}
												/>
												<span className='font-italic text-sm text-muted'>Promo will be available in selected operation area</span>
											</Form.Group>

											<Form.Group className={cx(s.space5, 'positionRelative')}>
												<label for='deliveryTypeId' className={'inputLabel'}>Delivery Type</label>
												<Field name="deliveryTypeId" className={cx(s.formControlSelect, s.formControlInput)} component="select">
													<option value="">All Delivery Types</option>
													{
														getActiveDeliveryType?.getActiveDeliveryType?.results
															?.map((deliveryType) => (
																<option key={deliveryType.id} value={deliveryType.id}>{deliveryType.deliveryName}</option>
															))
													}
												</Field>
												<span className='font-italic text-sm text-muted'>Promo will be available in selected delivery type</span>
											</Form.Group>

											{/* This field only visible in edit Promo Code */}
											{
												promoId &&
												<Form.Group className={cx(s.space5, 'positionRelative')}>
													<label for='isEnable' className={'inputLabel'}>{formatMessage(messages.status)}</label>
													<Field name="isEnable" className={cx(s.formControlSelect, s.formControlInput)} component="select">
														<option value="true">{formatMessage(messages.active)}</option>
														<option value="false">{formatMessage(messages.inactive)}</option>
													</Field>
												</Form.Group>
											}

										</Col>
									</Row>
								</div>
							</Col>

							<Col lg={12} md={12} sm={12} xs={12} className={cx(s.textAlignRight, s.spaceTop1, s.btnPadding, 'textAlignLeftRTL', 'btnPaddingRTL')}>
								<Form.Group className={s.noMargin}>
									<Link to={"/siteadmin/promo-code/list"} className={cx(s.backBtnTwo, s.btnSecondaryBorder, s.linkBtnInline, 'backBtnTwoRTL', s.backBtnTwoTop)} >{formatMessage(messages.goBack)}</Link>
									<div className={s.displayInlineBlock}>
										<Loader
											type={"button"}
											label={promoId ? formatMessage(messages.update) : formatMessage(messages.submitButton)}
											show={loading}
											buttonType={'submit'}
											className={cx(s.button, s.btnPrimary)}
											disabled={submitting || loading}
											isSuffix={true}
										/>
									</div>
								</Form.Group>
							</Col>
						</Row>
					</Form>
				</Container>
			</div>
		)
	}
}

const PromoCodeReduxForm = reduxForm({
	form: 'PromoCodeForm',
	onSubmit: submit,
	validate
})(PromoCodeForm);

const selector = formValueSelector('PromoCodeForm');

const mapState = state => ({
	currency: state.currency,
	promoId: selector(state, 'id'),
	promoType: selector(state, 'type'),
	promoCurrency: selector(state, 'currency'),
	validFrom: selector(state, 'validFrom'),
	expiryDate: selector(state, 'expiryDate'),
	promoCodeImage: selector(state, 'promoCodeImage'),
	isStockEnabled: selector(state, 'isStockEnabled'),
	isFirstOrderOnly: selector(state, 'isFirstOrderOnly'),
	loading: state.loader.AddPromoCode
});

const mapDispatch = {};

export default compose(
	injectIntl,
	withStyles(s),
	connect(mapState, mapDispatch),
	graphql(getLocationsQuery, {
		name: 'getLocations',
	}),
	graphql(getActiveDeliveryTypeQuery, {
		name: 'getActiveDeliveryType',
	})
)(PromoCodeReduxForm);
